module.exports = __webpack_public_path__ + "img/live2.12db2718.svg";